import React from "react";

interface ErrorScreenProps {
  icon?: string;
  title: string;
  message: string;
  buttonText?: string;
  onRetry?: () => void;
  isRetrying?: boolean;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({
  icon = "❌",
  title,
  message,
  buttonText = "Retry",
  onRetry,
  isRetrying = false,
}) => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
      }}>
      <div style={{ textAlign: "center", maxWidth: "400px", padding: "32px" }}>
        <div style={{ fontSize: "2rem", marginBottom: "16px" }}>{icon}</div>
        <h2
          style={{
            fontSize: "1.5rem",
            marginBottom: "16px",
            color: "#dc2626",
          }}>
          {title}
        </h2>
        <p style={{ color: "#6b7280", marginBottom: "24px" }}>{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            disabled={isRetrying}
            style={{
              padding: "12px 24px",
              backgroundColor: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "16px",
            }}>
            {isRetrying ? `${buttonText}...` : buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorScreen;
